export default {
    state: {
        routeFrom: {},
        routeTo: {},
        channelID: '',
        productID: '',
        orderSerialNo: ''
    },
    getters: {
        getRouteFrom: state => state.routeFrom,
        getRouteTo: state => state.routeTo,
        getchannelID: state => state.channelID,
        getproductID: state => state.productID,
        getorderSerialNo: state => state.orderSerialNo
    },
    mutations: {
        setRouteFrom(state, routeFrom) {
            state.routeFrom = routeFrom
        },
        setRouteTo(state, routeTo) {
            state.routeTo = routeTo
        },
        setchannelID(state, channelID) {
            state.channelID = channelID
        },
        setproductID(state, productID) {
            state.productID = productID
        },
        setorderSerialNo(state, orderSerialNo) {
            state.orderSerialNo = orderSerialNo
        }
    },
    actions: {}
}